import React, { useEffect, useState } from "react";

const SECOND = 1000;

const msUntil = (expiresAt) =>
  Math.max(0, new Date(expiresAt).getTime() - Date.now());

const pad = (value) => String(value).padStart(2, "0");

const OfferCountdown = ({ expiresAt, onExpire = () => {} }) => {
  const [remaining, setRemaining] = useState(() => msUntil(expiresAt));

  useEffect(() => {
    setRemaining(msUntil(expiresAt));
    const interval = setInterval(() => setRemaining(msUntil(expiresAt)), SECOND);
    return () => clearInterval(interval);
  }, [expiresAt]);

  useEffect(() => {
    if (remaining <= 0) onExpire();
  }, [remaining, onExpire]);

  const totalSeconds = Math.floor(remaining / SECOND);
  const parts = [
    { value: Math.floor(totalSeconds / 3600), unit: "h", label: "hours" },
    { value: Math.floor((totalSeconds % 3600) / 60), unit: "m", label: "minutes" },
    { value: totalSeconds % 60, unit: "s", label: "seconds" },
  ];

  return (
    <div
      className="table-request-countdown"
      role="timer"
      aria-label={`${parts[0].value} hours ${parts[1].value} minutes left to pay`}
    >
      {parts.map((part) => (
        <span className="table-request-countdown__part" key={part.unit}>
          <span className="table-request-countdown__value">{pad(part.value)}</span>
          <span className="table-request-countdown__unit" aria-hidden="true">
            {part.unit}
          </span>
          <span className="table-request-countdown__label" aria-hidden="true">
            {part.label}
          </span>
        </span>
      ))}
    </div>
  );
};

export default OfferCountdown;
